<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
  <g>
    <g>
      <circle class="filled" cx="16" cy="16" r="9.922" fill="currentColor"/>
      <rect class="cutout" x="11.143" y="14.6" width="9.713" height="2.8" fill="#fff"/>
    </g>
    <rect width="32" height="32" fill="none"/>
  </g>
</svg>
